import { useEffect, useState } from 'react';
import axios from 'axios';
import { useUser } from './useUser';

export const useNotifs = () => {
  const [notifs, setNotifs] = useState([]);
  const { user } = useUser();

  useEffect(() => {
    if (!user) {
      return;
    }
console.log(user.access)
      axios
        .get('/api/notifications/?limit=10&ordering=-id', {
          headers: {
            Authorization: `Bearer ${user.access}`,
          },
        })
        .then(data => {
          setNotifs(data.data);
          console.log(data.data)
        })
        .catch(error => {
          console.log(error)
        });
    
  }, []);

  return { notifs };
};
